<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../components-next/message/provider.js';
import BaseBubble from '../../components-next/message/bubbles/Base.vue';

// The message context provides all message props as refs.
// `contentAttributes` is camelCased by the MessageList component.
const { contentAttributes } = useMessageContext();

const stickerData = computed(() => {
  const attrs = contentAttributes.value || {};
  // Support both camelCase (lineSticker) and snake_case (line_sticker) formats
  return attrs.lineSticker || attrs.line_sticker || {};
});

const stickerUrl = computed(() => {
  const data = stickerData.value;
  // Support both camelCase and snake_case keys
  const packageId = data.packageId || data.package_id;
  const stickerId = data.stickerId || data.sticker_id;

  if (!packageId || !stickerId) {
    return null;
  }
  return `https://stickershop.line-scdn.net/stickershop/v1/sticker/${stickerId}/android/sticker.png`;
});

const stickerAlt = computed(() => {
  const data = stickerData.value;
  const packageId = data.packageId || data.package_id;
  const stickerId = data.stickerId || data.sticker_id;
  return packageId && stickerId
    ? `LINE Sticker ${packageId}-${stickerId}`
    : 'LINE Sticker';
});

const handleError = event => {
  // Hide the broken image icon on error to keep the UI clean.
  event.target.style.display = 'none';
};
</script>

<template>
  <BaseBubble class="px-2 py-2" data-bubble-name="line-sticker">
    <div class="max-w-[200px]">
      <img
        v-if="stickerUrl"
        :src="stickerUrl"
        :alt="stickerAlt"
        class="w-full h-auto rounded-lg shadow-md"
        @error="handleError"
      />
      <!-- This fallback should now only be visible if the data is truly missing -->
      <div
        v-else
        class="px-3 py-2 text-xs text-slate-500 bg-slate-100 rounded-lg"
      >
        {{ $t ? $t('LINE_STICKERS.MESSAGE_PLACEHOLDER') : '[LINE Sticker]' }}
      </div>
    </div>
  </BaseBubble>
</template>
